import { Trans } from "react-i18next";

import { Callout } from "@blueprintjs/core";

import CharMatchings from "./CharMatching";
import Delays from "./Delays";
import CountryPriority from "./CountryPriority";
import VehicleClasses from "./VehicleClasses";
import Tolerance from "./Tolerance";
import { useEffect, useState } from "react";

export default function DetectionClassificationSettings(props) {
  const [settings, setSettings] = useState([]);

  useEffect(() => {
    const sett = (
      <span key={"sett"+props.srv}>
        <Delays srv={props.srv} />
        <br />
        <CharMatchings srv={props.srv} />
        <br />
        <Tolerance srv={props.srv} />
        <br />
        <VehicleClasses srv={props.srv} />
        <br />
        <CountryPriority srv={props.srv} />
      </span>
    );
    setSettings(sett);
  }, [props.srv]);

  return (
    <Callout icon="widget-button" title={<Trans>ALPR</Trans>}>
      {settings}
    </Callout>
  );
}
